import React from "react";
import "./App.css";
import "./styles/victory.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, useLocation, useParams, Navigate } from "react-router-dom";
import Header from "./components/Header";
import LeaveReview from "./components/LeaveReview";
import MobileCallBar from "./components/MobileCallBar";
import ContactPage from "./pages/ContactPage";
import ServiceLandingPage from "./pages/ServiceLandingPage";
import { Footer } from "./sections/RestSections";
import HomePage from "./pages/HomePage";
import TeamPage from "./pages/TeamPage";
import CareersPage from "./pages/CareersPage";
import GalleryPage from "./pages/GalleryPage";
import AboutPage from "./pages/AboutPage";
import ReviewsPage from "./pages/ReviewsPage";
import ServicesPage from "./pages/ServicesPage";
import CityPage from "./pages/CityPage";
import ResidentialPage from "./pages/ResidentialPage";
import CommercialPage from "./pages/CommercialPage";
import BlogPage from "./pages/BlogPage";
import FaqPage from "./pages/FaqPage";
import BlogPostPage from "./pages/BlogPostPage";
import Analytics from "./components/Analytics";
import TradePartnerPage from "./pages/TradePartnerPage";

function ScrollTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function ServiceRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/residential/${slug}`} replace />;
}

function App() {
  return (
    <HelmetProvider>
    <div className="vp">
      <BrowserRouter>
        <ScrollTop />
        <Analytics />
        <a href="#main-content" className="skip-link">Skip to content</a>
        <Header />
        <div id="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/service-areas" element={<ServicesPage />} />
          <Route path="/service-areas/:city" element={<CityPage />} />
          <Route path="/residential" element={<ResidentialPage />} />
          <Route path="/residential/:slug" element={<ServiceLandingPage />} />
          <Route path="/commercial" element={<CommercialPage />} />
          <Route path="/commercial/:slug" element={<ServiceLandingPage />} />
          <Route path="/trade-partner" element={<TradePartnerPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/services/:slug" element={<ServiceRedirect />} />
        </Routes>
        </div>
        <Footer />
        <LeaveReview />
        <MobileCallBar />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
